module.exports = __webpack_public_path__ + "img/13.f0cbf38d.jpg";